const options = {
  5: "bg-amber-300/5",
  10: "bg-amber-300/10",
  25: "bg-amber-300/25",
  50: "bg-amber-300/50",
  75: "bg-amber-300/75",
  90: "bg-amber-300/90",
  100: "bg-amber-300",
};

const from = {
  5: "from-amber-300/5",
  10: "from-amber-300/10",
  25: "from-amber-300/25",
  50: "from-amber-300/50",
  75: "from-amber-300/75",
  90: "from-amber-300/90",
  100: "from-amber-300",
};

export default function getBackgroundAmber300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
